// removed by extract-text-webpack-plugin
module.exports = {"header":"header___3bMN6","controls-container":"controls-container___jqKJ5","wrapper":"wrapper___35NP9","search-bar":"search-bar___iKImy","image-container":"image-container___L9-HZ","header-logo-link":"header-logo-link___2LNNU","header-logo":"header-logo___2Jzma","search-field-container":"search-field-container___2O0qz","search-button-container":"search-button-container___1-KcN","search-field-icon":"search-field-icon___1JJJJ","mobile-search":"mobile-search___1CPVa","show":"show___1nmCt","white-label":"white-label___1yZV-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = ykdQ
// module chunks = 57